module.exports = __webpack_public_path__ + "img/cloth_g1_item_09.8e6b84da.svg";